import { getPageNameFromLocation } from "../../pages/helpers/analytics";
import phoneDemoEvents from "./phoneDemo";
import plangridTrackEvents, { trackEvent } from "./amplitudeInit-vanilla";
import getLocaleByGeoIP from "./getLocaleByGeoIP";

const addIndustryFormHandler = pageName => {
  const formContainer = document.querySelector(".industry-form-wrapper");
  const formNode = formContainer.querySelector("form");
  const formBtn = formContainer.querySelector("button");

  const submitIndustriesForm = () => {
    const industryForm = MktoForms2.getForm(1082);

    industryForm.onSuccess((values, followUpUrl) => {
      formContainer.classList.add("confirmation");
      trackEvent("public_web.page.engage.start", { from: pageName });
      return false;
    });

    industryForm.setValues({
      FirstName: formNode["First name"].value,
      LastName: formNode["Last name"].value,
      Email: formNode.Email.value,
      Company: formNode.Company.value,
      Phone: formNode["Phone number"].value,
      commentCapture: formNode["Your message"].value,
      optinDataCollection: formNode.optinDataCollection.checked ? "yes" : "no",
      optinMarketingCommunications: formNode.optinMarketingCommunications
        .checked
        ? "yes"
        : "no",
    });

    industryForm.submit();
  };

  formNode.addEventListener("submit", e => {
    e.preventDefault();

    formBtn.disabled = "disabled";

    submitIndustriesForm();
  });
};

const VIDEO_HANDLERS = {
  "/commercial": "hbpenzcxyh",
  "/education-industry": "83u6wt11tk",
};

const attachVideoHandlers = pageName => {
  const playIcon = document.querySelector(".industry-video-content-play-icon");

  if (playIcon) {
    window._wq = window._wq || [];

    const id = VIDEO_HANDLERS[pageName];

    _wq.push({
      id,
      onReady: function(vid) {
        vid.bind("play", () => {
          trackEvent("public_web.page.video.click", { from: pageName, id });
        });

        playIcon.addEventListener("click", e => {
          vid.play();
        });
      },
    });
  }
};

const updateCheckboxVisibilityForUX1Country = locale => {
  const checkboxWrapper = document.querySelectorAll(".checkbox-wrapper");
  const UX1Countries = ["in", "us", "mx"];
  if (UX1Countries.includes(locale)) {
    checkboxWrapper.forEach(each => {
      each.style = "display:none";
    });
  } else {
    checkboxWrapper.forEach(each => {
      const checkboxSelect = each.querySelector("input[type=checkbox]");
      if (checkboxSelect.name === "optinDataCollection") {
        checkboxSelect.required = true;
        checkboxSelect.oninvalid = function() {
          each.className += " required";
        };
      }
    });
    const formPrivacyWrapper = document.querySelector(".form-privacy");
    formPrivacyWrapper.style = "display:none";
  }
};

const init = () => {
  MktoForms2.loadForm("//app-ab10.marketo.com", "572-JSV-775", 1082);
  const pageName = getPageNameFromLocation(window.location.href);
  plangridTrackEvents(pageName);
  phoneDemoEvents();
  addIndustryFormHandler(pageName);
  attachVideoHandlers(pageName);
  getLocaleByGeoIP(updateCheckboxVisibilityForUX1Country);
};

document.addEventListener("DOMContentLoaded", init);



// WEBPACK FOOTER //
// ./src/assets/js/industry.js